import Axios from "axios";

import { SET_LEAVE_TYPE_LIST, UNSET_LEAVE_TYPE_LIST,SET_LEAVE_TYPE_DETAILS,UNSET_LEAVE_TYPE_DETAILS  } from "@/store/mutation-types";


import {
  leaveType as leaveTypeApi,
  saveUpdateLeaveType as saveUpdateLeaveTypeApi,
} from "@/store/api";

const state = {
  getLeaveTypeList: [],
  editingLeave: null,
  getLeaveTypeDetails: null,
};


const getters = {
  getLeaveTypeList(state) {
    return state.getLeaveTypeList;
  },
  getEditingLeave: (state) => state.editingLeave,
  getLeaveTypeDetails(state) {
    return state.getLeaveTypeDetails;
  },
};


// Mutations
const mutations = {
  [SET_LEAVE_TYPE_LIST](state, data) {
    state.getLeaveTypeList = data;
  },
  [UNSET_LEAVE_TYPE_LIST](state) {
    state.getLeaveTypeList = [];
  },
  [SET_LEAVE_TYPE_DETAILS](state, data) {
    state.getLeaveTypeDetails = data;
  },
  [UNSET_LEAVE_TYPE_DETAILS](state) {
    state.getLeaveTypeDetails = null;
  },
  setEditingLeave(state, leave) {
    state.editingLeave = leave;
  },
  // setViewingLeave(state, leave) {
  //   state.viewingVoucher = leave;
  // },
};

// Actions
const actions = {

    saveUpdateLeaveType({ commit }, data) {
        commit("SET_LOADING", {color: "primary"});
        return new Promise((resolve, reject) => {
        Axios.post(saveUpdateLeaveTypeApi, data)
            .then(function (response) {
            resolve(response);
            })
            .catch(function (error) {

            reject(error);
            })
            .then((always) => {
                commit("UNSET_LOADING");
            });
        });
    },

  getLeaveTypeList({ commit }, data) {
    commit("SET_LOADING", { color: "primary" });

    return new Promise((resolve, reject) => {
      Axios.get(`${leaveTypeApi}`, { params: data })
        .then((response) => {
          commit(SET_LEAVE_TYPE_LIST, response.data.data || []);
          resolve(response);
        })
        .catch((error) => {
          commit(UNSET_LEAVE_TYPE_LIST);
          reject(error);
        })
        .finally(() => {
          commit("UNSET_LOADING");
        });
    });
  },

getLeaveTypeDetails({ commit }, leave_type_id) {
  commit("SET_LOADING", { color: "primary" });

  return new Promise((resolve, reject) => {
    Axios.get(`${leaveTypeApi}/${leave_type_id}`)
      .then((response) => {
        commit("SET_LEAVE_TYPE_DETAILS", response.data.data || []);
        resolve(response);
      })
      .catch((error) => {
        commit("UNSET_LEAVE_TYPE_DETAILS");
        reject(error);
      })
      .finally(() => {
        commit("UNSET_LOADING");
      });
  });
},

  
};


export default {
  state,
  getters,
  actions,
  mutations,
};